import { SearchBar } from "../Input";
import { Filters } from "../Popovers/components/Filters";

const FilterBar = props => {
  const { inputs = [], formik } = props || {};

  const filterProps = {
    inputs,
    formik,
    type: "simple",
  };

  const searchBarProps = {
    name: "search",
    formik,
  };

  return (
    <div className="flex min-w-0 items-center gap-4">
      <div className="min-w-0 flex-1 sm:flex-none">
        <SearchBar {...searchBarProps} />
      </div>
      <Filters {...filterProps} />
    </div>
  );
};

export { FilterBar };
